export default __webpack_public_path__ + "static/media/grammarly_logo.1ac55e74.svg";